import { render, staticRenderFns } from "./ReportSalesAveragesPage.vue?vue&type=template&id=7448b9cc&scoped=true"
import script from "./ReportSalesAveragesPage.vue?vue&type=script&lang=js"
export * from "./ReportSalesAveragesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7448b9cc",
  null
  
)

export default component.exports